module.exports = __webpack_public_path__ + "static/media/cp.8621f432.svg";